module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAaCAYAAABozQZiAAAAAXNSR0IArs4c6QAAARlJREFUOE+1lEtOwzAURd9VEtENdAlMYjlZBBItIMIGYHvMaOmU3x7y7FWwAMrID7mKImLycys8jc7xteN3wcyPRHQB4EFr/UIRC8z8SURLItoDuNNav87lYYy5FJEdES1iBfC7WGtXzrnnWMEB9quu6zWAbYyghZsEaxHZishCRPZZllV5nr8N3UEH7hMAqIqi6BX8gb2Ama8AbHwCIvpKkqRSSr2HCXrhuYJBuE8gIlVZlm2CUbgRXBPRhojOmiPcKqU+/LdJeEwwC/YCY8yNiDz5BAC+nXPn/w8zc++5J3ceAicvLARn/6rwlYXg4M5HP09rbWeyZg9GDNiJHZZBmqajs9zCx7TIAT6pAE+q3l+lfx/T2T72Dweq6DmoHacsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_right_four.png
// module id = GlY+
// module chunks = 0